export const GUARANTEE_TEXTS = {
  title: 'Peace of Mind Guarantee',
  subTitle: "If you're not satisfied with the membership in the first 30 days, we will refund the cost of the membership, no questions asked.",
};

export const HEADER_TEXTS = {
  title: 'In a HelloTech home, technology just works',
  subTitle: 'The support you need for any smart home device, all in one package.',
};

export const META_TITLE = "HelloTech Smart Home Plans";
export const META_DESCRIPTION = "Find the ideal tech support plan for your needs with HelloTech. Explore our range of membership options designed to provide expert assistance and peace of mind for all your devices. Sign up today and experience hassle-free tech support.";
